import { render } from "./AddMonitorTarget.vue?vue&type=template&id=3152529d&scoped=true"
import script from "./AddMonitorTarget.vue?vue&type=script&lang=js"
export * from "./AddMonitorTarget.vue?vue&type=script&lang=js"

import "./AddMonitorTarget.vue?vue&type=style&index=0&id=3152529d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3152529d"],['__file',"src/containers/performance/AddMonitorTarget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3152529d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3152529d', __exports__)) {
    api.reload('3152529d', __exports__)
  }
  
  module.hot.accept("./AddMonitorTarget.vue?vue&type=template&id=3152529d&scoped=true", () => {
    api.rerender('3152529d', render)
  })

}


export default __exports__